export const getPageViewPayload = (companyId, storyId) => {
    const pageName = storyId
        ? 'companystory'
        : 'companyhubpremium';
    const payload = {
        pageName,
        pageType: 'blog',
        pageHierarchyLevel1: 'candidate',
    };
    if (companyId) {
        payload.companyId = companyId;
    }
    return JSON.stringify(payload);
};
const appendVariant = (base, append) => typeof base === 'string' && base.length ? `${base} ${append}` : append;
const hasPageViewEventBeenFired = () => {
    if (!window.stst_gt)
        return false;
    const globalTrackingEventsHistory = window.stst_gt.methods?.getEventHistory?.();
    if (!globalTrackingEventsHistory ||
        !Array.isArray(globalTrackingEventsHistory)) {
        return false;
    }
    return globalTrackingEventsHistory.some((event) => event.tealium_event === 'view');
};
export const waitForPageViewEvent = () => {
    return new Promise((resolve, reject) => {
        const interval = setInterval(() => {
            if (hasPageViewEventBeenFired()) {
                clearInterval(interval);
                resolve();
            }
        }, 100);
        // clear interval if CV fit score never loaded
        // or if it came back as good or perfect
        setTimeout(() => {
            clearInterval(interval);
            reject();
        }, 10000);
    });
};
export const trackVariant = async (variant, componentId, additionalData = {}) => {
    await waitForPageViewEvent();
    if (!window.utag_data) {
        return;
    }
    const abTestServerSide = appendVariant(window.utag_data.abTestServerSide, variant);
    window.utag_data.abTestServerSide = abTestServerSide;
    trackEvent({
        componentId,
        linkName: 'abTestingVariantAssign',
    }, {
        abTestServerSide,
        componentName: componentId,
        elementActioned: 'abTestingVariant',
        elementAction: 'assign',
        elementActionValue: 'noValue',
        eventName: ['noValue'],
        ...additionalData,
    });
};
export const trackEvent = (eventData, customData = {}) => {
    if (typeof window.stst_gt?.methods?.sendCustomEvent !== 'function') {
        return;
    }
    let finalLinkName = eventData.linkName;
    if (!finalLinkName) {
        const { elementActioned, elementAction } = customData;
        if (typeof elementActioned === 'string' &&
            typeof elementAction === 'string') {
            finalLinkName = `${elementActioned}${elementAction
                .charAt(0)
                .toUpperCase()}${elementAction.slice(1)}`;
        }
        else {
            finalLinkName = 'unknown';
        }
    }
    const enhancedCustomData = {
        // Work-around - everything in the utag_data is included in the tracking call. On job-ad, utag_data
        // contains `eventName: ['jobdetailview']` which causes custom events to be counted as listing views!
        // Se we set it to null. customData may still override by supplying a value.
        eventName: null,
        ...customData,
        link_name: `${eventData.componentId}:${finalLinkName}`,
    };
    const customEventData = { ...eventData, linkName: finalLinkName };
    // Workaround for RL to append the current abTestServerSide from utag_data
    // in every subsequent event, considering trackVariant is always fired first.
    if (window?.utag_data?.abTestServerSide) {
        enhancedCustomData.abTestServerSide = window.utag_data.abTestServerSide;
    }
    window.stst_gt.methods.sendCustomEvent('link', customEventData, enhancedCustomData);
};
